export default __webpack_public_path__ + "static/linkBg2-c3a19b4f93ee08e87bb3601e83ce7240.png";